import Button from "@/common/components/Button";
import SelectController from "@/common/components/SelectController";
import TextArea from "@/common/components/TextArea";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { SubmitHandler, useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { UpdateEstablishmentCompanyValidationSchema } from "../../schemas/updateEstablishmentCompany.schema";
import { useUsers } from "@/features/users/hooks/useUsers";
import { UserData } from "@/common/types/users";

interface CreatorSectionProps {
  establishmentCompany?: EstablishmentCompanyData;
  onSubmit: SubmitHandler<UpdateEstablishmentCompanyValidationSchema>;
  isUpdatePending?: boolean;
}

const CreatorSectionUpdate = ({ establishmentCompany, onSubmit, isUpdatePending }: CreatorSectionProps) => {
  const navigate = useNavigate();

  const [searchUsers, setSearchUsers] = useDebounce('');

  const { data: establishmentUsersOptions, isPending: establishmentUsersIsPending } = useUsers({
    filters: {
      search: searchUsers,
    },
    mapper: Mapper.mapToOptions<UserData>({ valueFieldName: 'id', labelFieldName: 'full_name' }),
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useFormContext<UpdateEstablishmentCompanyValidationSchema>();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-bold">
          Responsáveis internos
        </p>

        <div className="flex items-center gap-2">
          <Button variant="outline-error" onClick={() => navigate(`/establishments/${establishmentCompany?.id}`)} disabled={isUpdatePending}>
            Cancelar
          </Button>

          <Button name="submit" onClick={handleSubmit(onSubmit)} isLoading={isUpdatePending}>
            Salvar
          </Button>
        </div>
      </div>

      <SelectController
        control={control}
        name="commercial_manager"
        label="Responsável interno"
        markAsRequired
        errorMessage={errors?.commercial_manager?.message || undefined}
        onInputChange={setSearchUsers}
        options={establishmentUsersOptions || []}
        isLoading={establishmentUsersIsPending}
        isDisabled={isUpdatePending}
      />

      <SelectController
        control={control}
        name="commercial_manager_substitute"
        label="Responsável interno substituto"
        errorMessage={errors?.commercial_manager_substitute?.message || undefined}
        onInputChange={setSearchUsers}
        options={establishmentUsersOptions || []}
        isClearable
        isLoading={establishmentUsersIsPending}
        isDisabled={isUpdatePending}
      />

      <TextArea
        rows={5}
        markAsRequired
        label="Observações"
        {...register('observations')}
        errorMessage={errors.observations?.message || undefined}
        disabled={isUpdatePending}
      />
    </div>
  );
};

export default CreatorSectionUpdate;
